import React from "react";
import { Helmet } from "react-helmet-async";

export default function PageSeo({ 
  title, 
  description, 
  canonicalUrl, 
  schema, 
  ogImage = "https://pilotlinkusa.org/static/media/brand-logo-light.25b5c0faa770aed762c2.png" // Add a default image URL
}) {
  const fullTitle = `${title} | PilotLink USA`;
  const fullUrl = canonicalUrl ? `https://pilotlinkusa.org${canonicalUrl}` : "https://pilotlinkusa.org";

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      {/* Note: <meta name="keywords" /> is removed because Google ignores it. Focus on description instead. */}
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* JSON-LD Structured Data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}